import { Icon } from 'admin/components/common/Icon';
import React from 'react';

export type GoogleSpreadsheetOpenLinkProps = {
	href: string;
	children?: React.ReactNode;
	iconWidth?: number;
	className?: string;
	/** Used when `children` is omitted (icon-only control). */
	ariaLabel?: string;
};

export const GoogleSpreadsheetOpenLink: React.FC<GoogleSpreadsheetOpenLinkProps> = ({
	href,
	children,
	iconWidth = 24,
	className,
	ariaLabel = 'Open in Google Sheets',
}) => (
	<a
		href={href}
		target="_blank"
		rel="noopener noreferrer"
		className={className}
		aria-label={children ? undefined : ariaLabel}
		style={{
			display: 'inline-flex',
			alignItems: 'center',
			gap: children ? '0.25em' : 0,
			verticalAlign: 'middle',
		}}
	>
		<Icon type="open-external" color="currentColor" width={iconWidth} />
		{children}
	</a>
);
